import React, { FC, useEffect } from 'react';

import { isEmpty, map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { ECRImageContainersComponent } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/ECR/Components/ECRImageContainersComponent';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';
import { actions } from 'containers/Visibility/Vulnerabilities/slice';

interface Props {
  isOpen: boolean;
  onClose();
  row: any;
}

export const ImageContainers: FC<Props> = props => {
  const { isOpen, row } = props;
  const { ecrImageContainers, containerRiskContext } = useSelector(
    selectVulnerabilities,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    isOpen &&
      dispatch(
        actions.getECRImageContainers({
          q: { getContainersRequest: { image_names: [row?.uri] } },
          onSuccess: res => {
            if (isEmpty(res)) return;
            dispatch(
              actions.getContainerRiskContext({
                q: {
                  riskContextRequest: {
                    uuids: map(res, o => o?.resource_uuid!),
                  },
                },
              }),
            );
          },
        }),
      );
  }, [dispatch, isOpen, row]);

  return (
    <ECRImageContainersComponent
      {...props}
      containerRiskContext={containerRiskContext}
      ecrImageContainers={ecrImageContainers}
    />
  );
};
